import React from 'react'

import { dateToUTC } from '../../lib/formats'
import {
  CurrencyTypeProvider,
  MarginTypeProvider,
  DateTypeProvider,
  WrappedTextTypeProvider,
  CapitalizedTextTypeProvider
} from '../UI/FormatProviders'
import DataGrid from '../UI/DataGrid'

/*
Props:
- projectId: Mandatory! Get quotes for this project.
- disableHeader,
  disablePager,
  disableFilters,
  disableSearch,
  disableVisibility,
  rowClickFn,
  rowDetailComponent: passed down to DataGrid
*/
const ListQuotes = props => {
  const gridColumns = [
    { name: 'id', title: 'ID' },
    { name: 'name', title: 'Name' },
    { name: 'version', title: 'Version' },
    { name: 'state', title: 'State' },
    { name: 'date', title: 'Date' },
    { name: 'grossCost', title: 'Cost' },
    { name: 'grossTotal', title: 'Total' },
    { name: 'grossMargin', title: 'Margin' },
    { name: 'grandTotal', title: 'Total + taxes' }
  ]

  const gridRowMappingFn = quote => {
    const id = quote.id
    const {
      name,
      version,
      state,
      date,
      grossCost,
      grossTotal,
      grossMargin,
      grandTotal
    } = quote.attributes

    return {
      id,
      name,
      version: Number(version),
      state,
      date: dateToUTC(date),
      grossCost,
      grossTotal,
      grossMargin: Number(grossMargin) * 100,
      grandTotal
    }
  }

  const gridSorting = [
    { columnName: 'date', direction: 'desc' },
    { columnName: 'name', direction: 'asc' }
  ]
  const gridHiddenColumns = ['id', 'version']
  const tableColumnVisibilityExtensions = [
    { columnName: 'id', togglingEnabled: false },
    { columnName: 'name', togglingEnabled: false }
  ]

  const tableColumnExtensions = [
    { columnName: 'version', align: 'center', width: 100 },
    { columnName: 'state', width: 100 },
    { columnName: 'date', width: 160 },
    { columnName: 'grossCost', align: 'right', width: 180 },
    { columnName: 'grossTotal', align: 'right', width: 180 },
    { columnName: 'grossMargin', align: 'right', width: 120 },
    { columnName: 'grandTotal', align: 'right', width: 180 }
  ]

  // Formatted columns
  const typeProviders = [
    <WrappedTextTypeProvider key={0} for={['name']} />,
    <CapitalizedTextTypeProvider key={1} for={['state']} />,
    <DateTypeProvider key={2} for={['date']} />,
    <CurrencyTypeProvider
      key={3}
      for={['grossCost', 'grossTotal', 'grandTotal']}
    />,
    <MarginTypeProvider key={4} for={['grossMargin']} />
  ]

  // Server-side filtering
  const filters = { projectId: props.projectId }

  // Passthrough props
  const otherProps = {
    disableHeader: props.disableHeader,
    disablePager: props.disablePager,
    disableFilters: props.disableFilters,
    disableSearch: props.disableSearch,
    disableVisibility: props.disableVisibility,
    rowClickFn: props.rowClickFn,
    rowDetailComponent: props.rowDetailComponent
  }

  return (
    <DataGrid
      resourceAPIEndpoint="quotes"
      resourceSingularName="quote"
      resourcePluralName="quotes"
      newUrl={`/projects/${props.projectId}/quotes/new`}
      nameAttribute="name"
      serverFilters={filters}
      gridColumns={gridColumns}
      gridRowMappingFn={gridRowMappingFn}
      gridSorting={gridSorting}
      gridHiddenColumns={gridHiddenColumns}
      tableColumnVisibilityExtensions={tableColumnVisibilityExtensions}
      tableColumnExtensions={tableColumnExtensions}
      typeProviders={typeProviders}
      {...otherProps}
    />
  )
}

export default ListQuotes



// WEBPACK FOOTER //
// ./src/components/Quotes/ListQuotes.jsx